import cx from 'classnames';
import { FC, ReactNode, HTMLAttributes } from 'react';

type Variant = 'warning' | 'info' | 'error';

interface IFormControlHelpTextProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  variant?: Variant;
  icon?: boolean;
  italic?: boolean;
}

const getIcon = (variant: Variant) => {
  if (variant === 'warning') {
    return <i className="fa fa-exclamation-triangle slds-m-right--x-small" />;
  }

  if (variant === 'info') {
    return <i className="fa fa-info-circle slds-m-right--x-small" />;
  }

  if (variant === 'error') {
    return <i className="fa fa-exclamation-triangle slds-m-right--x-small" />;
  }

  return null;
};

export const FormControlHelpText: FC<IFormControlHelpTextProps> = ({
  children,
  variant = 'info',
  icon = false,
  italic = false,
  className,
  ...props
}: IFormControlHelpTextProps) => {
  return (
    <div
      className={cx(
        'slds-form-element__help slds-text-body--regular',
        variant === 'warning' && 'text-warning',
        variant === 'info' && 'text-muted',
        variant === 'error' && 'text-error',
        italic && 'text-italic',
        className
      )}
      {...props}
    >
      {icon && getIcon(variant)}
      {children}
    </div>
  );
};
